import { type RootState } from '../../../rmsReduxStore/rmsStore';

export default function getAcConfigureNotificationReducer(state: RootState) {
  return state.acConfigureNotificationReducer;
}
